import queryString from "query-string";

/**
 |--------------------------------------------------
 | Headers
 |--------------------------------------------------
 */
export default function queryParser(queries) {
    let params = [];
    let type;

    for (const [key, value] of Object.entries(queries)) {
        type = typeof value;

        if (type === undefined) continue;

        if (type === 'string') params[key] = value;
        if (type === 'number') params[key] = value;
        if (key === 'sortFields') params['sort'] = value;

        if (type === 'object') {
            for (const [key2, value2] of Object.entries(value)) {
                params[`${key}[${key2}]`] = value2;
            }
        }
    }

    return queryString.stringify(params);
}